import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from "../../context/AuthContext";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { convertTimestampToFrenchFormat } from "../../scripts/utils";
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";

export default function CatoStory({ setLink, storyId }) {
    const { apiUrl } = useContext(AuthContext);
    const { t } = useTranslation();

    const getStory = async () => {
        const res = await axios(`${apiUrl}cato/story/${storyId}`, {
            method: "get",
            withCredentials: true
        });

        return res.data;
    };

    const story = useQuery({
        queryKey: ["story", storyId],
        queryFn: getStory,
        enabled: !!storyId
    });

    return (
        <>
            {!story.isLoading ? (
                <>
                    <div className='cato-header-logo'>
                        <img className='logo_cato' src='./assets/cato_logo.svg' alt="logo cato" />
                        <button className="cato-header-logo-button" onClick={() => setLink()}>
                            <FontAwesomeIcon icon={faChevronLeft} color={'white'} />
                            {t("Retour")}</button>
                    </div>
                    <section className='cato-header'>
                        <div className='cato-header-type-stories'>
                            <h2 className='cato-header-type-title'>{t("Attack Detected")}</h2>
                            <div className='cato-header-type-content'>
                                <div className='cato-header-type-content'>
                                    <p>{story.data.incident.indication}</p>
                                </div>
                            </div>
                        </div>
                        <div className='cato-header-type-stories'>
                            <h2 className='cato-header-type-title'>{t('Producer')}</h2>
                            <div className='cato-header-type-content'>
                                <div className='cato-header-type-content'>
                                    <p><img className='logo_cato_items' src='./assets/cato_logo.svg' alt="logo cato" /> {story.data.incident.producer}</p>
                                </div>
                            </div>
                        </div>
                        <div className='cato-content-model'>
                            <p className={
                                story.data.incident.criticality >= 1 && story.data.incident.criticality <= 3 ? "paragraph-criticality criticality_green" :
                                    story.data.incident.criticality >= 4 && story.data.incident.criticality <= 6 ? "paragraph-criticality criticality_orange" :
                                        story.data.incident.criticality >= 7 && story.data.incident.criticality <= 10 ? "paragraph-criticality criticality_red" : ""
                            }>{story.data.incident.criticality}</p>
                            <div className='cato-content-model-resume'>
                                <p className='date'>{convertTimestampToFrenchFormat(story.data.createdAt, t('en-EN'))}</p>
                                <p>{t("Story Created")}</p>
                                <p>{story.data.incident.indication}</p>
                            </div>
                        </div>
                    </section>
                    <section className='p-10'>
                        <article className='cato-content-model-details-summary'>
                            <span className='cato-content-model-details-summary-icon'>
                                <FontAwesomeIcon icon={faInfoCircle} color={'#1a57ff'} />
                            </span>
                            <p>{story.data.summary}</p>
                        </article>
                    </section>
                    <section className='cato-content'>
                        <section className='cato-content-section'>
                            <div className='cato-content-container'>
                                <div className='cato-content-model-details'>
                                    <h2>{t("Details")}</h2>

                                    <div>
                                        <h3>Description :</h3>
                                        <p>{story.data.incident.description}</p>
                                    </div>
                                    <div>
                                        <h3>{t("Creation Date")} :</h3>
                                        <p>{convertTimestampToFrenchFormat(story.data.createdAt, t('en-EN'))}</p>
                                    </div>
                                    <div>
                                        <h3>{t("Updated date")} :</h3>
                                        <p>{convertTimestampToFrenchFormat(story.data.updatedAt, t('en-EN'))}</p>
                                    </div>
                                    <div>
                                        <h3>{t("Direction")} :</h3>
                                        <p className='direction'>{story.data.incident.direction}</p>
                                    </div>
                                    <div>
                                        <h3>{t("Criticality")} :</h3>
                                        <p className={
                                            story.data.incident.criticality >= 1 && story.data.incident.criticality <= 3 ? "paragraph-criticality criticality_green" :
                                                story.data.incident.criticality >= 4 && story.data.incident.criticality <= 6 ? "paragraph-criticality criticality_orange" :
                                                    story.data.incident.criticality >= 7 && story.data.incident.criticality <= 10 ? "paragraph-criticality criticality_red" : ""
                                        }>{story.data.incident.criticality}</p>
                                    </div>
                                    <div>
                                        <h3>Story ID :</h3>
                                        <p>{story.data.id}</p>
                                    </div>
                                </div>
                                <div className='cato-content-model-details'>
                                    <h2>Source</h2>
                                    <div>
                                        <h3>{t("Site Name")} :</h3>
                                        <p>{story.data.incident.site}</p>
                                    </div>
                                    <div>
                                        <h3>Ip :</h3>
                                        <p>{story.data.incident.source}</p>
                                    </div>
                                    <div>
                                        <h3>OS :</h3>
                                        <p>{story.data.incident.os}</p>
                                    </div>
                                    <div>
                                        <h3>{t("Device Name")} :</h3>
                                        <p>{story.data.incident.deviceName}</p>
                                    </div>
                                    <div>
                                        <h3>Mac Address :</h3>
                                        <p>{story.data.incident.macAddress}</p>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </section>
                </>
            ) : (
                <Loader />
            )}
        </>
    )
}